import {getSettingsHeaders} from "@next/utils"
import {IncomingHttpHeaders} from "http"
import {Store} from "@reduxjs/toolkit"
import {COUNTRY_GB, TERRITORY_HEADER} from "../../config/constants"

export const SET_REQUEST = "SET_REQUEST"

export interface SetRequest {
    type: typeof SET_REQUEST
    request: {
        headers: IncomingHttpHeaders
        url: string
    }
}

export interface RequestDuckState {
    headers: IncomingHttpHeaders | null
    url: string | null
    isInternationalCountry: boolean
}

const initialState: RequestDuckState = {
    headers: null,
    url: null,
    isInternationalCountry: false,
}

export const setRequestAction = (
    store: Store,
    request: {
        headers: IncomingHttpHeaders
        url: string
    },
) => {
    store.dispatch({
        type: SET_REQUEST,
        request,
    })
}

const reducer = (state: RequestDuckState = initialState, action: SetRequest): RequestDuckState => {
    switch (action.type) {
        case SET_REQUEST:
            return {
                ...state,
                headers: getSettingsHeaders(action.request.headers),
                url: action.request.url,
                isInternationalCountry:
                    typeof action.request.headers?.[TERRITORY_HEADER] === "string" &&
                    action.request.headers?.[TERRITORY_HEADER]?.toLowerCase() !== COUNTRY_GB,
            }
        default:
            return state
    }
}

export default reducer
